(function(){
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.martineRoutes || {};

  /* ---------------- Header hide/show on scroll ---------------- */
  var header = document.getElementById('siteHeader');
  if(header){
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function(){
      if(!ticking){
        window.requestAnimationFrame(function(){
          var y = window.scrollY;
          header.classList.toggle('scrolled', y > 8);
          if(y > lastY && y > 120){ header.classList.add('hide'); } else { header.classList.remove('hide'); }
          lastY = y; ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* ---------------- Mobile menu + cart drawer ---------------- */
  var scrim = document.getElementById('scrim');
  var mobileMenu = document.getElementById('mobileMenu');
  var cartDrawer = document.getElementById('cartDrawer');
  var menuOpenBtn = document.getElementById('menuOpenBtn');
  var cartOpenBtn = document.getElementById('cartOpenBtn');

  function openMenu(){ mobileMenu.classList.add('open'); scrim.classList.add('show'); menuOpenBtn && menuOpenBtn.setAttribute('aria-expanded','true'); }
  function closeMenu(){ mobileMenu.classList.remove('open'); if(!cartDrawer.classList.contains('open')) scrim.classList.remove('show'); menuOpenBtn && menuOpenBtn.setAttribute('aria-expanded','false'); }
  function openCart(){ cartDrawer.classList.add('open'); cartDrawer.setAttribute('aria-hidden','false'); scrim.classList.add('show'); cartOpenBtn && cartOpenBtn.setAttribute('aria-expanded','true'); }
  function closeCart(){ cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden','true'); if(!mobileMenu.classList.contains('open')) scrim.classList.remove('show'); cartOpenBtn && cartOpenBtn.setAttribute('aria-expanded','false'); }

  menuOpenBtn && menuOpenBtn.addEventListener('click', openMenu);
  document.getElementById('cartCloseBtn') && document.getElementById('cartCloseBtn').addEventListener('click', closeCart);
  cartOpenBtn && cartOpenBtn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
  scrim && scrim.addEventListener('click', function(){ closeMenu(); closeCart(); });
  mobileMenu && mobileMenu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });

  /* ---------------- Cart data helpers ---------------- */
  function updateCartCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
  }

  function refreshCartDrawer(){
    if(!routes.cartUrl) return Promise.resolve();
    var url = window.location.pathname + window.location.search;
    url += (window.location.search ? '&' : '?') + 'section_id=cart-drawer';
    return fetch(url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cartDrawer');
        if(fresh && cartDrawer){
          var wasOpen = cartDrawer.classList.contains('open');
          cartDrawer.innerHTML = fresh.innerHTML;
          if(wasOpen) cartDrawer.classList.add('open');
        }
      });
  }

  function changeCartLine(key, dir){
    if(!routes.cartChangeUrl) return;
    var body = { id: key };
    if(dir === 'remove'){ body.quantity = 0; }
    else {
      var lineEl = document.querySelector('[data-cart-qty][data-key="' + key + '"]');
      var group = lineEl ? lineEl.closest('.cart-line') : null;
      var current = group ? parseInt(group.querySelector('.qty .n').textContent, 10) : 1;
      body.quantity = Math.max(0, current + parseInt(dir, 10));
    }
    fetch(routes.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function(r){ return r.json(); })
      .then(function(cartData){
        updateCartCount(cartData.item_count);
        if(document.body.dataset.template === 'cart'){
          window.location.reload();
        } else {
          refreshCartDrawer();
        }
      });
  }

  function addToCart(variantId, quantity){
    if(!routes.cartAddUrl) return Promise.reject();
    return fetch(routes.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function(r){
      if(!r.ok){ return r.json().then(function(err){ throw err; }); }
      return r.json();
    });
  }

  function afterAdd(){
    if(!routes.cartUrl) return;
    fetch(routes.cartUrl + '.js')
      .then(function(r){ return r.json(); })
      .then(function(cartData){
        updateCartCount(cartData.item_count);
        refreshCartDrawer().then(openCart);
      });
  }

  /* ---------------- Delegated cart interactions ---------------- */
  document.addEventListener('click', function(e){
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if(qtyBtn){
      changeCartLine(qtyBtn.dataset.key, qtyBtn.dataset.dir);
      return;
    }
    var quickAdd = e.target.closest('[data-quick-add]');
    if(quickAdd){
      e.preventDefault();
      var original = quickAdd.textContent;
      quickAdd.disabled = true;
      quickAdd.textContent = 'Adding…';
      addToCart(quickAdd.dataset.variantId, 1)
        .then(afterAdd)
        .catch(function(){ quickAdd.textContent = 'Sold out'; })
        .finally(function(){ quickAdd.disabled = false; if(quickAdd.textContent === 'Adding…') quickAdd.textContent = original; });
      return;
    }
  });

  /* ---------------- Product form (variant picker + add to cart) ---------------- */
  var productForm = document.getElementById('product-form');
  if(productForm){
    var scriptEl = document.querySelector('script[id^="ProductJson-"]');
    var variants = scriptEl ? JSON.parse(scriptEl.textContent) : [];
    var variantIdInput = document.getElementById('pdVariantId');
    var priceEl = document.getElementById('pdPrice');
    var mainImg = document.getElementById('pdMainImg');
    var addBtn = document.getElementById('pdAddToCart');
    var soldOutEl = document.getElementById('pdSoldOut');
    var qtyInput = document.getElementById('pdQtyInput');

    function money(cents){
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant(){
      var groups = productForm.querySelectorAll('.variant-row');
      var selected = Array.prototype.map.call(groups, function(g){
        var active = g.querySelector('.variant-pill[aria-pressed="true"]');
        return active ? active.dataset.optionValue : null;
      });
      return variants.filter(function(v){
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function(val, i){ return val === null || opts[i] === val; });
      })[0];
    }

    function selectVariant(v){
      if(!v) return;
      variantIdInput.value = v.id;
      if(priceEl) priceEl.textContent = money(v.price);
      if(v.featured_image && mainImg){ mainImg.src = v.featured_image.src; }
      if(v.available){
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        if(soldOutEl) soldOutEl.style.display = 'none';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
        if(soldOutEl) soldOutEl.style.display = 'block';
      }
    }

    productForm.addEventListener('click', function(e){
      var pill = e.target.closest('.variant-pill');
      if(pill){
        var group = pill.closest('.variant-row');
        group.querySelectorAll('.variant-pill').forEach(function(p){ p.setAttribute('aria-pressed','false'); });
        pill.setAttribute('aria-pressed','true');
        selectVariant(findVariant());
        return;
      }
      var qtyBtn = e.target.closest('[data-qty-dir]');
      if(qtyBtn){
        var val = Math.max(1, (parseInt(qtyInput.value,10) || 1) + parseInt(qtyBtn.dataset.qtyDir,10));
        qtyInput.value = val;
        return;
      }
    });

    var thumbs = document.querySelectorAll('.pd-thumb');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
        if(mainImg && t.dataset.pdImage){ mainImg.src = t.dataset.pdImage; }
      });
    });

    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addToCart(variantIdInput.value, parseInt(qtyInput.value,10) || 1)
        .then(afterAdd)
        .catch(function(){ addBtn.textContent = 'Couldn\'t add — try again'; })
        .finally(function(){
          setTimeout(function(){ addBtn.disabled = false; addBtn.textContent = original; }, 1200);
        });
    });
  }

  /* ---------------- Product image zoom / lightbox ---------------- */
  var pdMainMedia = document.getElementById('pdMainMedia');
  if(pdMainMedia){
    var overlay = document.createElement('div');
    overlay.className = 'zoom-overlay';
    overlay.innerHTML = '<button type="button" class="zoom-close" aria-label="Close zoomed image">✕</button><img alt="">';
    document.body.appendChild(overlay);
    var overlayImg = overlay.querySelector('img');
    var closeZoom = function(){ overlay.classList.remove('open'); };
    pdMainMedia.addEventListener('click', function(){
      var img = pdMainMedia.querySelector('img');
      if(!img) return;
      overlayImg.src = img.src;
      overlayImg.alt = img.alt || '';
      overlay.classList.add('open');
    });
    overlay.addEventListener('click', closeZoom);
    overlay.querySelector('.zoom-close').addEventListener('click', function(e){ e.stopPropagation(); closeZoom(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeZoom(); });
  }

  /* ---------------- Imagination Garden hero: animated depth gallery of paintings ---------------- */
  var gardenStage = document.querySelector('[data-garden-stage]');
  if(gardenStage){
    var frames = Array.prototype.slice.call(gardenStage.querySelectorAll('[data-garden-frame]'));
    var nav = document.querySelector('[data-garden-nav]');
    var dots = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-garden-dot]')) : [];

    if(!reduceMotion && frames.length > 1){
      gardenStage.classList.add('js-garden');
      if(nav) nav.classList.add('js-active');

      var order = frames.map(function(f, i){ return i; });
      var roleNames = ['center','left','right','back'];
      var timer = null;
      var INTERVAL = 4500;
      var tabHidden = false;

      function applyRoles(){
        order.forEach(function(frameIndex, pos){
          var role = roleNames[pos] || 'hidden';
          frames[frameIndex].setAttribute('data-role', role);
        });
        dots.forEach(function(d, i){
          d.setAttribute('aria-current', String(i === order[0]));
        });
      }

      function advance(){
        order.push(order.shift());
        applyRoles();
      }

      function goTo(index){
        var pos = order.indexOf(index);
        if(pos <= 0) return;
        order.splice(pos, 1);
        order.unshift(index);
        applyRoles();
        restart();
      }

      function start(){ if(!tabHidden){ timer = window.setInterval(advance, INTERVAL); } }
      function stop(){ if(timer){ window.clearInterval(timer); timer = null; } }
      function restart(){ stop(); start(); }

      applyRoles();
      start();

      gardenStage.addEventListener('mouseenter', stop);
      gardenStage.addEventListener('mouseleave', start);
      gardenStage.addEventListener('focusin', stop);
      gardenStage.addEventListener('focusout', start);

      /* pause while the tab is hidden, so nothing runs off-screen */
      document.addEventListener('visibilitychange', function(){
        tabHidden = document.hidden;
        if(tabHidden){ stop(); } else { start(); }
      });

      dots.forEach(function(d, i){
        d.addEventListener('click', function(){ goTo(i); });
      });

      /* touch swipe */
      var touchStartX = null;
      gardenStage.addEventListener('touchstart', function(e){
        touchStartX = e.touches[0].clientX;
        stop();
      }, { passive:true });
      gardenStage.addEventListener('touchend', function(e){
        if(touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if(Math.abs(dx) > 40){
          if(dx < 0){ advance(); } else { order.unshift(order.pop()); applyRoles(); }
        }
        touchStartX = null;
        start();
      }, { passive:true });

      /* keyboard arrows when the stage or its frames have focus */
      gardenStage.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ advance(); restart(); }
        else if(e.key === 'ArrowLeft'){ order.unshift(order.pop()); applyRoles(); restart(); }
      });
    }

    /* Gentle scroll handoff: fade the petal/branch layer out as the visitor scrolls past the garden into the real gallery */
    var gardenHero = document.querySelector('.garden-hero');
    var petalLayer = document.querySelector('.garden-petals');
    var branchLayer = document.querySelector('.garden-branch');
    if(gardenHero && !reduceMotion && (petalLayer || branchLayer)){
      var handoffTicking = false;
      window.addEventListener('scroll', function(){
        if(handoffTicking) return;
        handoffTicking = true;
        window.requestAnimationFrame(function(){
          var rect = gardenHero.getBoundingClientRect();
          var progress = Math.min(1, Math.max(0, 1 - (rect.bottom / (rect.height || 1))));
          var fade = 1 - progress;
          if(petalLayer) petalLayer.style.opacity = fade;
          if(branchLayer) branchLayer.style.opacity = (0.9 * fade);
          handoffTicking = false;
        });
      }, { passive:true });
    }
  }

  /* ---------------- Related products (recommendations API) ---------------- */
  var relatedEl = document.querySelector('[data-related-products]');
  if(relatedEl && relatedEl.dataset.url){
    fetch(relatedEl.dataset.url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-related-products]');
        if(fresh){ relatedEl.innerHTML = fresh.innerHTML; }
      });
  }

  /* ---------------- Newsletter success scroll-into-view ---------------- */
  var signupNote = document.querySelector('.signup-note');
  if(signupNote && signupNote.textContent.trim() !== ''){
    signupNote.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* ---------------- Scroll-reveal choreography ---------------- */
  var revealSelectors = '.product-card, .art-frame, .journal-card, .trust-tile, .review-card, .art-story, .showcase-card, .story-begins-media, .story-begins-copy, .featured-artwork-media, .featured-artwork-copy, .meet-artist-photo, .meet-artist-copy, .intro-martine, .section-head, .garden-copy, .martine-note-card, .dream-band .wrap';
  var revealEls = Array.prototype.slice.call(document.querySelectorAll(revealSelectors));
  if(reduceMotion){
    revealEls.forEach(function(el){ el.classList.add('reveal','is-visible'); });
  } else if(revealEls.length){
    revealEls.forEach(function(el, i){
      el.classList.add('reveal');
      el.style.transitionDelay = (Math.min(i % 6, 5) * 70) + 'ms';
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el){ io.observe(el); });
  }
})();
